//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NotificationConfirmation from './notification-confirmation.vue';
import _            from 'lodash';

export default {
    props : {
        from_manager_page: {},
        subscription_confirmed: false,
        user: {},
        subscription_type: {},
        subscribable_items: {},
        notification_frequencies: {},
        user_frequency: {},
        manager_page_url: {},
        notification_hash: {},
        cancel_subscriptions: {},
        is_tax: {},
        current_term: {},
        current_post_type: {},
        current_language: {}
    },
    data : function () {
        return {
            translations: rest_options.options.translations,
            mutable_subscription_type: this.subscription_type,
            mutable_user_frequency: this.user_frequency,
            mutable_post_type_model: {},
            mutable_term_model: {},
            subscribable: this.subscribable_items,
            subscriptions_shorthand: null,
            email: '',
            confirmed: false,
            subscriptions: '',
            showModal: false,
            rest_options: rest_options,
            new_subscriber: false,
            running_ajax: false,
            invalid_email: false,
            mutable_user: this.user,
            cancel: false
        }
    },
    components : {
        NotificationConfirmation
    },
    beforeMount () {
    },
    mounted () {
        if(this.notification_hash) {
            this.getSubscriptions();
        } else {
            this.new_subscriber = true
        }
        if (this.is_tax == 0 && this.current_post_type) {
            this.mutable_subscription_type = 1;
            //this.mutable_post_type_model[this.current_post_type] = true;

            // Exception: add announcement as checked, if post type page is news_item
            if(this.current_post_type === 'news_item') {
              this.mutable_post_type_model['announcement'] = true;
            }

        } else if (this.is_tax == 1 && this.current_term){
            this.mustable_subscription_type = 0;
            this.mutable_term_model[this.current_term['term_id']] = true;
        }
    },
    watch : {
        email (value) {
            this.checkUser(value);
        }
    },
    methods : {
        getSubscriptions () {
            this.running_ajax = true;
            this.$http.get('/wp-json/vtv/v1/notification/get_subscriptions', {
                params : {
                    hash : this.notification_hash
                }
            }).then(response => {
                let subscriptions_shorthand = {};
                let model = {};
                let type = '';
                for(let i in response.body) {
                    let item = response.body[i];
                    type = item.type;

                    if(subscriptions_shorthand[item.type] == undefined) {
                        subscriptions_shorthand[item.type] = {};
                    }
                    subscriptions_shorthand[item.type][item.to_name] = item;
                    if(type == 'terms') {
                        model[item.to_term] = true;
                    } else if (type == 'post_types'){
                        model[item.to_name] = true;
                    }
                }
                this.subscriptions_shorthand = subscriptions_shorthand;

                if(type == 'terms') {
                    this.mutable_term_model = model;
                } else {
                    this.mutable_post_type_model = model;
                }
                this.running_ajax = false;
            }).catch(error => {
            });
        },
        getSubscribable () {
            this.running_ajax = true;
            this.$http.get('/wp-json/vtv/v1/notification/get_subscribable_items').then(response => {
                this.subscribable = response.body;
                this.running_ajax = false;
            }).catch(error => {
            })
        },
        capitalizeFirstLetter(string) {
            string = string.toLowerCase();
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        subscribe () {
            let email = (this.mutable_user) ? this.mutable_user['email'] : this.email;
            console.log(email);
            if(!this.validEmail(email)) {
                this.invalid_email = true;
                this.$refs.email.focus();
                return false;
            }
            let type;
            let frequency = this.mutable_user_frequency;
            const post_types = _.cloneDeep(this.mutable_post_type_model);
            const terms = _.cloneDeep(this.mutable_term_model);
            let subscriptions = {'post-types' : post_types, 'terms' : terms};
            this.running_ajax = true;
            this.$http.post('/wp-json/vtv/v1/notification/subscribe', {
                params : {
                    notification_hash : this.notification_hash,
                    notification_email : this.email,
                    subscription_type : this.mutable_subscription_type,
                    subscriptions : subscriptions,
                    notification_frequency : this.mutable_user_frequency,
                    update_subscriptions : true,
                    new_subscription : this.new_subscriber,
                    current_language : this.current_language
                }
            }).then((response) => {
                this.scrollUp();
                this.invalid_email = false;
                this.confirmed = true;
                this.running_ajax = false;
            }).catch((error) => {
            });

        },
        unsubscribe () {
            this.running_ajax = true;
            this.$http.post('/wp-json/vtv/v1/notification/subscribe', {
                params : {
                    notification_hash : this.notification_hash,
                    notification_email : this.email,
                    cancel_subscriptions : true
                }
            }).then((response) => {
                this.scrollUp();
                this.showModal = false;
                this.confirmed = true;
                this.running_ajax = false;
                this.mutable_post_type_model = [];
                this.mutable_term_model = [];
                this.cancel = true;
            }).catch((error) => {
            });
        },
        scrollUp () {
            let container = document.getElementById('notification-order-form-modal__content');
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            container.scrollTop = 0;
        },
        validEmail (email) {
          const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return re.test(email);
        },
        checkUser : _.debounce(function (value) {
            this.$http.get('/wp-json/vtv/v1/notification/get_user_by_email', {
                params : {
                    email : value
                }
            }).then((response) => {
                if(response.body != false) {
                    this.new_subscriber = false;
                } else {
                    this.new_subscriber = true;
                }
            }).catch((error) => {
            });
        }, 500),
        isChild (term) {
            if (term.parent != 0) {
                return true;
            } else {
                return false;
            }
        },
        toggle_filters : function (item) {
            if(item.nesting_level > 0 && item.parent && this.mutable_term_model[item.parent] === true) {
                this.mutable_term_model[item.parent] = false;
            }
            if(item && item.children && this.mutable_term_model[item.id] === true) {
                for(var i in item.children) {
                    this.mutable_term_model[item.children[i]] = true
                }
            } else if (item && item.children && this.mutable_term_model[item.id] === false) {
                for(var i in item.children) {
                    this.mutable_term_model[item.children[i]] = false
                }
            }
        },
    }
}



// WEBPACK FOOTER //
// ./js/vue/notification-manager/notification-order-form.vue